import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { NotificationService } from '../services/notification-data.service';

@Injectable()
export class ApimInterceptor implements HttpInterceptor {

  constructor(
    private notificationService: NotificationService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.notificationService.setUpdateBellNotifyFlagByLastRequestTime(new Date());

    request = request.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': environment.apiKey
      }
    });

    return next.handle(request).pipe(timeout(360*1000)); //timeout 設為6分鐘
  }
}
